import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b6e3a2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute top-0 flex flex-row gap-10 my-10" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = { class: "saving-spinner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "moduleConfiguratorSkeleton"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "moduleConfiguratorSkeletonBuildInfo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "animateLine animateLoader" }),
  /*#__PURE__*/_createElementVNode("div", { class: "animateLine animateLoader" }),
  /*#__PURE__*/_createElementVNode("div", { class: "animateLine animateLoader" })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "moduleConfiguratorSkeletonToolbar" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "animateLine animateLoader" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "animateLine animateLoader" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "primary" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "animateLine animateLoader" })
  ])
], -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { ClientMessageType, ProductDetailCoverMaterial } from '@/types/productServerApi';
import { B2CSiteContextModel } from '@/types/B2CcontentServerContract';
import { maybeSoftRedirect } from '@/core/navigation/redirect.service';
import messagesStore from '@/core/messages/messages.store';
import authStore from '@/shared/auth/auth.store';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import { QueryKeys } from '@/shared/config/route-query.config';
import siteContextStore from '@/shared/content/site-context.store';
import serverContextStore from '@/shared/content/server-context.store';
import { useModuleConfigurator } from '@/shared/product/details/ui/module-configurator/useModuleConfigurator';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import useProductDetailPage from '@/shared/product/details/useProductDetailPage';
import pageStore from '@/shared/content/page.store';
import useNetPrices from '@/b2b/product/useNetPrices';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleConfigurator',
  props: {
    isToggled: { type: Boolean },
    toggle: null,
    series: null,
    cover: null,
    initialProduct: null,
    initialVariant: null
  },
  setup(__props: any) {

const props = __props as {
    isToggled: boolean,
    toggle:() => void,
    series: string,
    cover?: ProductDetailCoverMaterial,
    initialProduct: string,
    initialVariant: string,
}



const headers = siteContextStore.siteHeaders.reduce((item, { key, value }) => {
    item[key] = value;
    return item;
}, {});

const {
    toggleHideStyleSheet,
    getImage,
    getAllImages,
    getConfig,
    getSummary,
    getMeasure,
    clearConfig,
    setConfig,
    initialLegs,
    saveConfiguration,
    configurationData,
    textLabels,
    fallbackLabels,
    newEditGuid,
    toggleConfigurator,
} = useModuleConfigurator();

const { updateConfiguration } = useProductDetailPage();
const { getNetPrices } = useNetPrices();

const configuratorRef = ref(null);
const isSaving = ref(false);

const loaded = ref(false);
const showPreloader = ref(false);
const devMode = false;
const initialized = ref(false);
const configurationId = useRouteQuery(QueryKeys.PDPConfigurationId);
const editGuid = useRouteQuery(QueryKeys.Edit);
const startOpened = useRouteQuery(QueryKeys.OpenCustomizerModel);

const redirectSpaNewCheckout = computed(() => {
    return pageStore.isB2CPageLayout ? (siteContextStore.settings as B2CSiteContextModel).isNewCheckOutEnabled : false;
});

const showNetPrices = computed<boolean>(() => {
    return authStore.isSignedInAsPartner && authStore.showNetPrice;
});

const closeConfigurator = () => {
    try {
        window.ModuleConfigurator.removeEventlistener('save', getSaveConfiguration);
        window.ModuleConfigurator.removeEventlistener('ready', configurationReady);
    } catch (e) {
        // console.log(e);
    }

    props.toggle();
    window.ModuleConfigurator.dispose();
    toggleHideStyleSheet(true);
    setTimeout(() => {
        initialized.value = false;
    }, 100);
};

const configurationLoaded = () => {
    loaded.value = true;
    console.log('configurator loaded');
};

const checkSaveConfiguration = () => {
    const regex = /"uid":\d+,?/g; // strip uid before comparison because it's not relevant for comparing content
    const initial = configurationData.value ? JSON.stringify(configurationData.value).replace(regex, '') : null;
    const current = window.ModuleConfigurator.getConfigurationJSON().replace(regex, '');
    const edited = configurationData.value !== null;

    if (initial === current) {
        closeConfigurator();
    } else {
        getSaveConfiguration(edited);
    }
};

const getSaveConfiguration = async(isEdited?: boolean) => {
    isSaving.value = true;

    const configurationSaveId = await saveConfiguration(configurationId, editGuid);
    if (configurationSaveId.guid) {
        closeConfigurator();
        if (configurationSaveId.editGuid) {
            maybeSoftRedirect({ url: siteContextStore.settings.basketPageUrl, spaLink: redirectSpaNewCheckout.value });
        } else if (isEdited) {
            updateConfiguration(configurationSaveId.redirectId, configurationSaveId.guid, newEditGuid);
        } else {
            updateConfiguration(configurationSaveId.redirectId, configurationSaveId.guid);
        }

        isSaving.value = false;
    } else {
        messagesStore.addApiMessages([{ labelKey: '', message: 'Error saving configuration', messageType: ClientMessageType.Error }]);
        isSaving.value = false;
    }
};

const startConfigurator = async() => {
    if (authStore.accessToken && authStore.refreshToken) {
        try {
            await authStore.tryRefreshExpiredAccessToken();
            startConfiguratorAfterRefresh();
        } catch (e) {
            startConfiguratorAfterRefresh();
        }
    } else {
        startConfiguratorAfterRefresh();
    }
};

const startConfiguratorAfterRefresh = () => {
    const initialConfig = configurationData.value ? JSON.stringify(configurationData.value) : null;
    if (window.ModuleConfigurator) {
        const initObj = {
            debugMode: false,
            domContainerSelector: '#moduleConfigurator',
            apiBaseUrl: `${serverContextStore.apiEndPoint}/api`,
            apiRequestHeaders:
                {
                    Authorization: `Bearer ${authStore.accessToken}`,
                    'X-Language': headers['X-Language'],
                    'X-Retail-Channel': headers['X-Retail-Channel'],
                    'X-Assortment-Id': headers['X-Assortment-Id'],
                    'X-Country': headers['X-Country'],
                },
            productImageUrlTemplate: 'https://images.bolia.com/cdn-cgi/image/background=transparent,fit=contain,width=256,format=auto,height=256,quality=81/products/{sku}.webp?v=1',
            materialImageUrlTemplate: 'https://images.bolia.com/cdn-cgi/image/background=transparent,format=auto,quality=33,fit=crop,width=400,height=320/materials/{path}.webp?v=0',
            productSeries: props.series,
            initialConfig,
            initialCover: { group: props.cover?.name, name: props.cover?.color.name },
            initialLegs: { group: '', name: initialLegs.value || '' },
            initialProductId: props.initialProduct,
            depthDiffAlertCM: 25,
            texts: textLabels.value || fallbackLabels.texts,
            netPriceLookupFunc: showNetPrices.value ? getNetPrices : undefined,
            showNetPrices: showNetPrices.value,
        };

        window.ModuleConfigurator.init(initObj);

        if (configuratorRef.value) {
            (configuratorRef.value as HTMLDivElement).addEventListener('ready', configurationReady);
            (configuratorRef.value as HTMLDivElement).addEventListener('save', checkSaveConfiguration);
        }

        initialized.value = true;
    }
};

const configurationReady = () => {
    console.log('configurator ready');
    showPreloader.value = false;
    window.ModuleConfigurator.enforceResize();
};

const configurationLoadError = () => {
    console.log('error loading appbundle.js');
    messagesStore.addApiMessages([{ labelKey: '', message: 'Error loading configurator', messageType: ClientMessageType.Error }]);
    try {
        closeConfigurator();
    } catch (e) {}
};

const loadConfigurator = () => {
    showPreloader.value = true;
    if (!document.head.querySelector('#moduleConfiguratorLoader') && props.isToggled) {
        const script = document.createElement('script');
        script.id = 'moduleConfiguratorLoader';

        script.src = serverContextStore.moduleConfiguratorJsBundleUrl;

        script.async = true;
        script.defer = true;
        script.onload = configurationLoaded;
        script.onerror = configurationLoadError;
        document.head.appendChild(script);
    }
};

const launchModuleConfigurator = () => {
    if (loaded.value && props.isToggled && !window.ModuleConfigurator) {
        // TODO, add custom type definition so eslint disable can be removed
        /* eslint-disable */
        /* @ts-ignore */
        window.ModuleConfigurator = new Configurator(serverContextStore.moduleConfiguratorBaseUrl);
        //DEV Note, due to incompatibility with vue ref and the external script in regards to drag events etc., attaching to window object is necessary

        /* eslint-enable */
    }
    if (loaded.value && configuratorRef.value && window.ModuleConfigurator && !initialized.value && props.isToggled) {
        toggleHideStyleSheet(false);
        console.log('start configuration');
        startConfigurator();
    }
};

watch(() => [configuratorRef.value, initialized.value, loaded.value], launchModuleConfigurator);
watch(() => props.isToggled, loadConfigurator);

onMounted(() => {
    if (document.head.querySelector('#moduleConfiguratorLoader') && window.ModuleConfigurator) {
        loaded.value = true;
        showPreloader.value = true;
        toggleHideStyleSheet(true); // configurator is already loaded
    }

    if (startOpened.value) {
        startOpened.value = '';
        toggleConfigurator();
    }
});

onUnmounted(() => {
    showPreloader.value = false;
    toggleHideStyleSheet(true);
    try {
        window.ModuleConfigurator.dispose();
    } catch (e) {}
});


return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BaseDialog, {
      "is-open": __props.isToggled,
      class: _normalizeClass(["fixed inset-0 z-1 bg-white md:flex items-center justify-center configurator-overlay", {'flex-col': devMode}]),
      onClose: _cache[9] || (_cache[9] = ($event: any) => (closeConfigurator()))
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(clearConfig)()))
          }, " dispose "),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setConfig)('conf1')))
          }, " conf1 "),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(getConfig)()))
          }, " get json "),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(getSummary)()))
          }, " get summary "),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(getImage)('top')))
          }, " get image (top) "),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(getMeasure)()))
          }, " get image (front, measure) "),
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(getAllImages)()))
          }, " get all images "),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (getSaveConfiguration()))
          }, " save config ")
        ], 512), [
          [_vShow, devMode]
        ]),
        (isSaving.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, _toDisplayString(_unref(textLabels).savingConfiguration), 1),
                _hoisted_4
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["demo-container", {'is-saving': isSaving.value}])
        }, [
          (!showPreloader.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "mobile-close",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (closeConfigurator()))
              }, [
                _createVNode(_component_c_icon, {
                  name: "icon-plus",
                  class: "rotate-45"
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: "moduleConfigurator",
            ref_key: "configuratorRef",
            ref: configuratorRef
          }, null, 512),
          (showPreloader.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["is-open", "class"])
  ]))
}
}

})